import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import querystring from 'query-string';
import invariant from 'invariant';

export default function getDetails(params) {
    const { baseUrl, brandId, country, language, uberToken, clientId, clientSecret } = params;

    invariant(baseUrl, 'baseUrl is a required param of getDetails()');
    invariant(brandId, 'brandId is a required param of getDetails()');
    invariant(country, 'country is a required param of getDetails()');
    invariant(language, 'language is a required param of getDetails()');
    invariant(uberToken, 'uberToken is a required param of getDetails()');
    invariant(clientId, 'clientId is a required param of getDetails()');

    const query = querystring.stringify({ brandId });
    const url = `${baseUrl}${language}-${country.toLowerCase()}/account/@self/details?${query}`;

    return labelRequest(authenticatedRequest(new Request(url), uberToken, clientId, clientSecret), 'getDetails');
}
